import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=0dade9ed&lang=pug&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=0dade9ed&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dade9ed')) {
      api.createRecord('0dade9ed', component.options)
    } else {
      api.reload('0dade9ed', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=0dade9ed&lang=pug&", function () {
      api.rerender('0dade9ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Checkbox.vue"
export default component.exports